<script>
import CallSumIcon from "@/assets/images/icons/meeting.svg";
import { VDateInput } from "vuetify/labs/VDateInput";
import { useGeneralStore } from "@/store/General";
import { useLeadsStore } from "@/store/crm/useLeadsStore";
import apiClient from "@/core/buildRequest";

export default {
  name: "AddMeeting",
  props: {
    addCallSummaryDialog: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  components: { VDateInput },
  data() {
    return {
      CallSumIcon: CallSumIcon,
      meetingDate: null,
      startTime: "",
      endTime: "",
      meetingDateTime: "",
      comment: "",
      showLinkDialog: false,
      linkUrl: "",
      linkText: "",
      showUsersList: false,
      showColumnsList: false,
      mentionTriggerPos: -1,
      columnTriggerPos: -1,
      users: [
        { id: 1, name: "John Doe", email: "john@example.com" },
        { id: 2, name: "Jane Smith", email: "jane@example.com" },
        { id: 3, name: "Mike Johnson", email: "mike@example.com" },
      ],
      columns: [],
      mentions: [],
      general_store: useGeneralStore(),
      store: useLeadsStore(),

    };
  },
  watch: {
    displayDateTime(newVal) {
      this.meetingDateTime = newVal;
    },
  },
  computed: {
    filteredUsers() {
      if (this.mentionTriggerPos === -1) return this.users;
      const searchText = this.comment
        .slice(this.mentionTriggerPos + 1)
        .toLowerCase();
      return this.users.filter((user) =>
        user.name.toLowerCase().includes(searchText)
      );
    },
    formattedComment() {
      let formatted = this.comment;
      const sortedMentions = [...this.mentions].sort(
        (a, b) => b.position - a.position
      );
      sortedMentions.forEach((mention) => {
        const beforeMention = formatted.slice(0, mention.position);
        const afterMention = formatted.slice(
          mention.position + mention.name.length + 1
        );
        formatted = `${beforeMention}<span class="mention">@${mention.name}</span>${afterMention}`;
      });
      formatted = formatted.replace(
        /{([^}]+)}/g,
        '<span class="column">{$1}</span>'
      );
      formatted = formatted.replace(
        /\[([^\]]+)\]\(([^)]+)\)/g,
        '<a href="$2">$1</a>'
      );
      formatted = formatted.replace(/\n/g, "<br>");
      return formatted;
    },
    processedComment() {
      let processed = this.comment;
      const sortedMentions = [...this.mentions].sort(
        (a, b) => b.position - a.position
      );
      sortedMentions.forEach((mention) => {
        const beforeMention = processed.slice(0, mention.position);
        const afterMention = processed.slice(
          mention.position + mention.name.length + 1
        );
        processed = `${beforeMention}@${mention.id}${afterMention}`;
      });
      return processed;
    },
    displayDateTime() {
      if (!this.meetingDate || !this.startTime || !this.endTime) return "";
      return `${this.formatDateFromInput(this.meetingDate)}`;
    },
  },
  methods: {
    handleInput(e) {
      const cursorPosition = e.target.selectionStart;
      const textBeforeCursor = this.comment.slice(0, cursorPosition);
      const lastChar = textBeforeCursor[textBeforeCursor.length - 1];

      if (lastChar === "@") {
        this.mentionTriggerPos = cursorPosition - 1;
        this.showUsersList = true;
        this.showColumnsList = false;
      } else if (lastChar === "{") {
        this.columnTriggerPos = cursorPosition - 1;
        this.showColumnsList = true;
        this.showUsersList = false;
      }
      this.updateMentionsPositions(cursorPosition);
    },
    updateMentionsPositions(cursorPosition) {
      this.mentions = this.mentions.map((mention) => {
        if (mention.position >= cursorPosition) {
          return {
            ...mention,
            position: mention.position + 1,
          };
        }
        return mention;
      });
    },
    handleKeyup(e) {
      if (e.key === "Escape") {
        this.showUsersList = false;
        this.showColumnsList = false;
      }
    },
    selectUser(user) {
      const textarea = this.$refs.commentTextarea;
      const cursorPos = textarea.selectionStart;
      const textBeforeMention = this.comment.slice(0, this.mentionTriggerPos);
      const textAfterMention = this.comment.slice(cursorPos);

      this.mentions.push({
        id: user.id,
        name: user.name,
        position: this.mentionTriggerPos,
      });

      this.comment = `${textBeforeMention}@${user.name} ${textAfterMention}`;
      this.showUsersList = false;
      this.mentionTriggerPos = -1;

      this.$nextTick(() => {
        textarea.focus();
        const newCursorPos = textBeforeMention.length + user.name.length + 2;
        textarea.setSelectionRange(newCursorPos, newCursorPos);
      });
    },
    selectColumn(column) {
      const textarea = this.$refs.commentTextarea;
      const cursorPos = textarea.selectionStart;
      const textBeforeColumn = this.comment.slice(0, this.columnTriggerPos);
      const textAfterColumn = this.comment.slice(cursorPos);

      this.comment = `${textBeforeColumn}{${column.name}} ${textAfterColumn}`;
      this.showColumnsList = false;
      this.columnTriggerPos = -1;

      this.$nextTick(() => {
        textarea.focus();
        const newCursorPos = textBeforeColumn.length + column.name.length + 3;
        textarea.setSelectionRange(newCursorPos, newCursorPos);
      });
    },
    toggleUsersList() {
      this.showUsersList = !this.showUsersList;
      this.showColumnsList = false;
      if (this.showUsersList) {
        this.mentionTriggerPos = this.comment.length;
        this.comment += "@";
        this.$nextTick(() => {
          this.$refs.commentTextarea.focus();
        });
      }
    },
    toggleColumnsList() {
      this.showColumnsList = !this.showColumnsList;
      this.showUsersList = false;
      if (this.showColumnsList) {
        this.columnTriggerPos = this.comment.length;
        this.comment += "{";
        this.$nextTick(() => {
          this.$refs.commentTextarea.focus();
        });
      }
    },
    formatDateFromInput(date) {
      if (!date) return "";
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
        2,
        "0"
      )}-${String(d.getDate()).padStart(2, "0")}`;
    },
    addLink() {
      this.linkUrl = "";
      this.linkText = "";
      this.showLinkDialog = true;
    }
    ,
    insertLink() {
      if (!this.linkUrl) return;

      const link = `[${this.linkText || this.linkUrl}](${this.linkUrl})`;
      const textarea = this.$refs.commentTextarea;
      const cursorPos = textarea.selectionStart;

      this.comment =
        this.comment.slice(0, cursorPos) +
        link +
        this.comment.slice(cursorPos);

      this.$nextTick(() => {
        textarea.focus();
        const newCursorPos = cursorPos + link.length;
        textarea.setSelectionRange(newCursorPos, newCursorPos);
      });

      this.showLinkDialog = false;
    },
    async getItemById() {
      this.store.commentsList = "";
      try {
        const response = await apiClient.get(
          `/leads-managment/get-lead/${this.store.sitem.id}`
        );
        if (response && response.data && response.data.data) {
          console.log(response.data.data.overview, "new data");
          this.store.commentsList = response.data.data.overview;
        } else {
          console.error("Unexpected API response structure:", response);
        }
      } catch (error) {
        console.error("Error fetching lead data:", error);
      }
    },
    saveMeeting() {
      if (this.formattedComment.length === 0) {
        this.general_store?.showSnackbar("Comment field is empty", "error");
        return;
      }
      if (!this.meetingDate || !this.startTime || !this.endTime) {
        this.general_store?.showSnackbar(
          "Meeting date, start time and end time are required",
          "error"
        );
        return;
      }
      apiClient
        .post(`/leads-managment/overview/${this.item.id}`, {
          content: this.formattedComment,
          from: `${this.formatDateFromInput(this.meetingDate)} ${this.startTime
            }`,
          to: `${this.formatDateFromInput(this.meetingDate)} ${this.endTime}`,
          type: "Call Summary",
        })
        .then((res) => {
          this.store?.getAllActivities(this.item.id);

          this.general_store?.showSnackbar("Meeting added", "#237276");
          this.getItemById();
        })
        .catch((error) => {
          this.general_store?.showSnackbar("Error Sending Data", "error");
        });
      this.closeDialog();
    },
    closeDialog() {
      this.$emit("update:addCallSummaryDialog", false);
      this.meetingDate = "";
      this.startTime = "";
      this.endTime = "";
      this.comment = "";
      this.mentions = [];
    },
  },
  mounted() {
    const leadStore = useLeadsStore();
    this.columns = leadStore.headers;
  },
};
</script>
<template>
  <div class="dialog-overlay" v-if="addCallSummaryDialog" @click.self="closeDialog">
    <div class="dialog-card">
      <div class="add-meeting-container">
        <!-- Header -->
        <div class="head d-flex align-center justify-space-between">
          <div class="title-icon d-flex align-center ga-2">
            <div class="icon">
              <img width="24" :src="CallSumIcon" alt="Meeting" />
            </div>
            <div class="name">Call Summary</div>
          </div>
          <div class="close cursor-pointer" @click="closeDialog">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M9 1L1 9M1 1L9 9" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
        </div>

        <!-- Date and Time Pickers -->
        <div class="date-time-section">
          <div class="date d-flex align-center ga-2">
            <span class="vuetify-date-input-icon cursor-pointer">
              <v-date-input hide-details variant="plain" prepend-icon="" prepend-inner-icon="$calendar"
                density="compact" clearable format="YYYY-MM-DD" v-model="meetingDate">
                <template v-slot:text-field="{ value }">
                  <v-text-field :model-value="formatDate(value)" readonly variant="plain"></v-text-field>
                </template>
              </v-date-input>
            </span>

            <span>{{ displayDateTime }}</span>
            <input type="time" v-model="startTime" />
            <input type="time" v-model="endTime" />
          </div>
        </div>

        <!-- Comment Area -->
        <div class="content">
          <textarea v-model="comment" rows="10" placeholder="Write a Comment" @input="handleInput" @keyup="handleKeyup"
            ref="commentTextarea"></textarea>

          <!-- Mention Users Dropdown -->
          <div v-if="showUsersList" class="mentions-dropdown">
            <div v-for="user in filteredUsers" :key="user.id" class="mention-item" @click="selectUser(user)">
              {{ user.name }}
            </div>
          </div>

          <!-- Columns Dropdown -->
          <div v-if="showColumnsList" class="columns-dropdown">
            <div v-for="column in columns" :key="column.id" class="column-item" @click="selectColumn(column)">
              {{ column.name }}
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="footer d-flex align-center justify-space-between">
          <div class="add-link d-flex align-center ga-3">
            <button class="add cursor-pointer" @click="saveMeeting">Add</button>
            <button class="link-btn" @click="addLink">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.49935 14.1673H5.83268C4.72761 14.1673 3.66781 13.7283 2.8864 12.9469C2.105 12.1655 1.66602 11.1057 1.66602 10.0007C1.66602 8.89558 2.105 7.83577 2.8864 7.05437C3.66781 6.27297 4.72761 5.83398 5.83268 5.83398H7.49935"
                  stroke="#666666" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M12.5 5.83398H14.1667C15.2717 5.83398 16.3315 6.27297 17.1129 7.05437C17.8943 7.83577 18.3333 8.89558 18.3333 10.0007C18.3333 11.1057 17.8943 12.1655 17.1129 12.9469C16.3315 13.7283 15.2717 14.1673 14.1667 14.1673H12.5"
                  stroke="#666666" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.66602 10H13.3327" stroke="#666666" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
            <v-dialog v-model="showLinkDialog" max-width="500">
              <v-card>
                <v-card-title class="text-h6">Insert Link</v-card-title>
                <v-card-text>
                  <v-text-field density="compact" variant="outlined" v-model="linkUrl" label="URL" />
                  <v-text-field density="compact" variant="outlined" v-model="linkText" label="Link Text" />
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn text @click="showLinkDialog = false">Cancel</v-btn>
                  <v-btn color="teal" @click="insertLink">Insert</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>

          <div class="mention-columns d-flex align-center ga-2">
            <button class="mention d-flex align-center ga-2" @click="toggleUsersList">
              <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.9262 5.49463C11.8647 4.54847 11.5778 3.63075 11.0894 2.81808C10.5553 1.95865 9.81143 1.24912 8.92777 0.756158C8.0441 0.263199 7.04961 0.00299806 6.03775 5.09009e-06H6.00698C4.82674 -0.00153203 3.67225 0.345102 2.68806 0.996516C1.70386 1.64793 0.933669 2.57518 0.473903 3.6622C0.0141383 4.74921 -0.114777 5.9477 0.103296 7.10763C0.321369 8.26755 0.87674 9.33739 1.69989 10.1832C2.67826 11.188 3.97746 11.8188 5.37217 11.966C6.76689 12.1132 8.16915 11.7677 9.33575 10.9893C9.43006 10.9211 9.49514 10.8198 9.51795 10.7057C9.54077 10.5916 9.51965 10.4731 9.45881 10.374C9.39254 10.2774 9.29163 10.2102 9.17705 10.1861C9.06246 10.162 8.94302 10.183 8.84352 10.2447C8.06875 10.7624 7.16644 11.0569 6.23545 11.0958C5.30445 11.1348 4.3807 10.9167 3.56541 10.4655C2.75012 10.0144 2.07474 9.34747 1.61327 8.53796C1.15181 7.72844 0.922071 6.80753 0.949224 5.87611C1.01302 4.56474 1.57291 3.32665 2.51546 2.41267C3.458 1.49868 4.71273 0.977146 6.02544 0.953719C7.2949 0.937521 8.52152 1.41243 9.44911 2.27924C10.3767 3.14606 10.9335 4.33774 11.0032 5.60538L11.0771 6.44834C11.0771 7.30361 10.5848 8.02966 9.99412 8.02966C9.40344 8.02966 8.9235 7.30361 8.9235 6.44834V3.53798C8.9235 3.41559 8.87488 3.29821 8.78834 3.21166C8.7018 3.12512 8.58442 3.0765 8.46203 3.0765C8.33964 3.0765 8.22226 3.12512 8.13572 3.21166C8.04917 3.29821 8.00055 3.41559 8.00055 3.53798V3.87639C7.57111 3.46894 7.02805 3.2015 6.44326 3.10948C5.85848 3.01745 5.25953 3.10518 4.7257 3.36104C4.19187 3.61691 3.74832 4.02885 3.45376 4.54234C3.1592 5.05584 3.02751 5.64668 3.07613 6.23666C3.12475 6.82664 3.35138 7.38795 3.72603 7.8463C4.10068 8.30465 4.60569 8.63842 5.1742 8.80344C5.74272 8.96846 6.34794 8.95695 6.90978 8.77044C7.47161 8.58392 7.96356 8.23119 8.32051 7.75893C8.4649 8.09086 8.69935 8.37573 8.99732 8.58126C9.29529 8.78679 9.64486 8.90478 10.0064 8.92185C11.1078 8.92185 12 7.79585 12 6.37451L11.9262 5.49463ZM6.00698 7.9989C5.61148 7.9989 5.22485 7.88162 4.896 7.66188C4.56715 7.44215 4.31084 7.12984 4.15948 6.76443C4.00813 6.39903 3.96853 5.99696 4.04569 5.60905C4.12285 5.22114 4.3133 4.86482 4.59297 4.58516C4.87263 4.30549 5.22895 4.11503 5.61686 4.03787C6.00477 3.96071 6.40684 4.00032 6.77225 4.15167C7.13765 4.30302 7.44996 4.55933 7.66969 4.88819C7.88943 5.21704 8.00671 5.60367 8.00671 5.99917C8.00508 6.52903 7.79388 7.03673 7.41921 7.4114C7.04454 7.78607 6.53685 7.99727 6.00698 7.9989Z"
                  fill="#666666" />
              </svg>
              Mention
            </button>
            <button class="columns d-flex align-center ga-2" @click="toggleColumnsList">
              <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M3.80952 15.1432C4.07252 15.1432 4.28571 14.93 4.28571 14.667C4.28571 14.404 4.07252 14.1908 3.80952 14.1908H3.57143C2.78245 14.1908 2.14285 13.5512 2.14285 12.7622V9.77367C2.14285 9.43948 2.02569 9.11586 1.81173 8.85912L1.09604 8.00029L1.81173 7.14145C2.02569 6.88472 2.14285 6.5611 2.14285 6.2269V3.23838C2.14285 2.4494 2.78245 1.8098 3.57143 1.8098H3.80952C4.07252 1.8098 4.28571 1.59661 4.28571 1.33361C4.28571 1.07062 4.07252 0.857422 3.80952 0.857422H3.57143C2.25647 0.857422 1.19047 1.92341 1.19047 3.23838V6.2269C1.19047 6.33831 1.15142 6.44617 1.08009 6.53176L0.110375 7.69543C-0.0367917 7.87203 -0.0367917 8.12855 0.110375 8.30514L1.08009 9.46881C1.15142 9.55441 1.19047 9.66227 1.19047 9.77367V12.7622C1.19047 14.0772 2.25647 15.1432 3.57143 15.1432H3.80952Z"
                  fill="#666666" />
                <path
                  d="M6.19103 15.1432C5.92803 15.1432 5.71484 14.93 5.71484 14.667C5.71484 14.404 5.92803 14.1908 6.19103 14.1908H6.42913C7.21811 14.1908 7.8577 13.5512 7.8577 12.7622V9.77367C7.8577 9.43948 7.97487 9.11586 8.18882 8.85912L8.90451 8.00029L8.18882 7.14145C7.97487 6.88472 7.8577 6.5611 7.8577 6.2269V3.23838C7.8577 2.4494 7.21811 1.8098 6.42913 1.8098H6.19103C5.92803 1.8098 5.71484 1.59661 5.71484 1.33361C5.71484 1.07062 5.92803 0.857422 6.19103 0.857422H6.42913C7.74408 0.857422 8.81009 1.92341 8.81009 3.23838V6.2269C8.81009 6.33831 8.84913 6.44617 8.92047 6.53176L9.89018 7.69543C10.0373 7.87203 10.0373 8.12855 9.89018 8.30514L8.92047 9.46881C8.84913 9.55441 8.81009 9.66227 8.81009 9.77367V12.7622C8.81009 14.0772 7.74408 15.1432 6.42913 15.1432H6.19103Z"
                  fill="#666666" />
              </svg>
              Columns
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.date-input {
  display: none;
}

.time-buttons {
  margin-left: 12px;
}

.time-btn {
  background: none;
  border: 1px solid #e0e0e0;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #666666;
}

.time-btn:hover {
  background: #f5f5f5;
}

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.dialog-card {
  background: white;
  border-radius: 8px;
  min-width: 500px;
  max-width: 800px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

.add-meeting-container {
  display: flex;
  flex-direction: column;
}

.head {
  height: 55px;
  padding: 11px 12px;
  background-color: #f2f2f2;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.date {
  padding: 11px 12px;
  height: 42px;
  border-bottom: 0.5px solid #d6d6d6;
  background-color: unset;
}

.content {
  padding: 15px;
  position: relative;
}

textarea {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
  resize: vertical;
}

textarea:focus {
  outline: none;
  border-color: #237276;
}

.footer {
  padding: 11px 12px;
  border-top: 1px solid #e0e0e0;
}

.add {
  height: 32px;
  padding: 4px 17px;
  border-radius: 8px;
  background: #237276;
  color: white;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
}

.add:hover {
  background: #1a5558;
}

.link-btn,
.mention,
.columns {
  background: none;
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  color: #666666;
  font-size: 12px;
}

.mentions-dropdown,
.columns-dropdown {
  position: absolute;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  width: 200px;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.mention-item,
.column-item {
  padding: 8px 12px;
  cursor: pointer;
  transition: background 0.2s;
}

.mention-item:hover,
.column-item:hover {
  background: #f5f5f5;
}

.d-flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.justify-space-between {
  justify-content: space-between;
}

.ga-2 {
  gap: 8px;
}

.ga-3 {
  gap: 12px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
